import ApiService from './ApiService.js'
import store from '../store'

export default {
    getHeader() {
        let authData = store.getters.authData;        
        return {
            "Authorization": "Bearer " + authData.access_token,
            'Content-Type': 'application/json',
            "Accept": "application/hal+json"
        };
    },
    getMemberInfo() {
        var header = this.getHeader();
        return ApiService().get('api/member-identity',
        { 
            headers: header
        });
    }
}